<template>
  <div>
    {{ message.content }}
    <div v-for="file in message.files" :key="file.id">
      <a class="filedownload" :href="file.base64" :download="file.meta.name"><i class="fa fa-file"> {{ file.meta.name }} </i></a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AttachmentMessage',
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>
<style scoped>
.filedownload {
  color: #0055CC;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/AttachmentMessage.vue